export const departments = [
  'Trust Signal',
  'Bread',
  'Ethics',
  'Data',
  'KRO Exchange'
];

// ...existing code...

export const menus = {
  'Trust Signal': {
    'AM Signal': [],
    'FM Signal': [],
    'Ubuntu Signal': []
  },
  'Bread': {
    'Onboarding Guide': [],
    'Risk Assessment': [],
    'Trust & Security Scanning': [
      'Trust Score Analysis',
      'Privacy Assessment',
      'Security Evaluation',
      'Regulatory Compliance'
    ],
    'Access Management': [
      'User Management',
      'Roles & Permissions',
      'Audit Logs',
      'Security Settings'
    ],
    'Compliance Tools': [
      'Overview',
      'Policies'
    ],
    'Operations Management': [
      'Overview',
      'Production Analytics'
    ],
    'Engagement Analytics': [
      'Overview',
      'User Engagement', 
      'Performance Reports',
      'Dashboard Analytics'
    ],
    'Quality Control': []
  },
  'Ethics': {
    'Onboarding Guide': [],
    'Distribution Partners': [],
    'Supply Chain Ethics': [
      'Overview',
      'Supplier Assessment',
      'Ethical Sourcing'
    ],
    'Cultural & Global Impact': [
      'Localization',
      'Community Engagement',
      'Cultural Framework',
      'Impact Assessment'
    ],
    'Supplier Ecosystem': [
      'Supplier Dashboard',
      'Onboarding Process',
      'Performance Monitoring',
      'Communication Hub'
    ]
  },
  'Data': {
    'Onboarding Guide': [],
    'Foundational Investment': [],
    'Investor Dashboard': [],
    'Analytics & Intelligence': [      
      'Raw Intelligence',
      'Predictive Analytics',
      'Custom Reports'
    ],
    'Business Intelligence': [
      'Market Analysis',
      'Performance Metrics',
      'Engagement Insights'
    ],
    'Stewardship Intelligence': []
  },
  'KRO Exchange': {
    'Payment Workflow': [],
    'Settlement Hub': [
      'Execution Gateway',
      'Canton Network',
      'Settlement Records'
    ],
    'ESG Intelligence': [],
    'Customer Service Portal': []
  }
};